import { IinvoiceEditorFields } from "./InvoiceEditor.types";
import { currencies, invoiceTypes, paymentMethods, yesNo } from "./constants";
import { comboboxOption } from "./constants";
const today = new Date();
export const invoiceEditorFields = (suppliers: comboboxOption[], categories: comboboxOption[]): IinvoiceEditorFields[] => [

  {
    name: "invoiceId",
    label: "Invoice ID",
    componentType: "input",
    disabled: true,
    inputType: "text",
    required: true,
    rows: 0
  },
  {
    name: "userId",
    label: "User ID",
    componentType: "hide",
    disabled: true,
    inputType: "text",
    required: true,
    rows: 0
  },
  {
    name: "stageId",
    label: "Stage ID",
    componentType: "input",
    disabled: true,
    inputType: "number",
    required: true,
    rows: 0
  },
  {
    name: "adminUserId",
    label: "Admin User ID",
    componentType: "hide", //Set it to hide to not show it
    disabled: true,
    inputType: "text",
    required: false,
    rows: 0
  },
  {
    name: "documentUrl",
    label: "Document URL",
    componentType: "input",
    disabled: true,
    inputType: "text",
    required: true,
    rows: 0
  },
  {
    name: "documentOwner",
    label: "User",
    componentType: "input",
    disabled: false,
    inputType: "text",
    required: false,
    placeholder: "Please enter user name",
    rows: 0
  },
  {
    name: "type",
    label: "Type",
    componentType: "dropdown",
    disabled: false,
    // inputType: "text",
    required: false,
    options: [
      "Invoice",
      "Statement",
      "Receipt",
      "Credit Note",
      "Delivery Note",
      "Other",
    ],
    rows: 0
  },
  {
    name: "invoiceDate",
    label: "Invoice Date",
    componentType: "date",
    disabled: false,
    required: true,
    dateFormat: "DD-MM-YYYY",
    // minDate: new Date("2020-01-01"),
    maxDate: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
    rows: 0
  },

  // {
  //   name: "supplier",
  //   label: "Supplier",
  //   componentType: "combobox",
  //   disabled: false,
  //   inputType: "text",
  //   required: true,
  //   allowAddNew: true,
  //   placeholder: "Please enter supplier name",
  //   rows: 0
  // },
   {
    name: "supplier",
    label: "Supplier",
    componentType: "combobox",
    disabled: false,
    inputType: "text",
    required: false,
    options:  suppliers,
    placeholder: "Please enter supplier name",
    rows: 0,
    allowAddNew: true,
    addNewType: "supplier",
    idFieldName: "supplierId",
  },
  {
    name: "extractedPoNumber",
    label: "Extracted PO Number",
    componentType: "input",
    disabled: false,
    inputType: "text",
    required: false,
    placeholder: "Please enter purchase order number",
    rows: 0
  },
  {
    name: "documentReference",
    label: "Document Reference",
    componentType: "input",
    disabled: false,
    inputType: "text",
    required: true,
    placeholder: "Please enter document reference",
    rows: 0
  },
  {
    name: "dueDate",
    label: "Due Date",
    componentType: "date",
    disabled: false,
    inputType: "text",
    required: false,
    rows: 0
  },
  {
    name: "category",
    label: "Category",
    componentType: "combobox",
    disabled: false,
    inputType: "text",
    required: true,
    options:  categories,
    rows: 0,
    allowAddNew: true,
    addNewType: "category",
    idFieldName: "categoryId",
  },
  {
    name: "productOrService",
    label: "Product Or Service",
    componentType: "input",
    disabled: false,
    inputType: "text",
    required: false,
    placeholder: "Please enter product or service",
    rows: 0
  },
  {
    name: "customer",
    label: "Customer",
    componentType: "input",
    disabled: false,
    inputType: "text",
    required: false,
    placeholder: "Please enter customer name",
    rows: 0
  },
  {
    name: "markAsRebillable",
    label: "Mark As Rebillable",
    componentType: "dropdown",
    disabled: false,
    // inputType: "text",
    required: false,
    options: ["Yes", "No"],
    rows: 0
  },
  {
    name: "description",
    label: "Description",
    componentType: "textarea",
    disabled: false,
    inputType: "text",
    required: false,
    placeholder: "Please enter description",
    rows: 0
  },
  {
    name: "amount",
    label: "Amount",
    componentType: "hide",
    disabled: false,
    inputType: "number",
    required: false,
    rows: 0
  },
  {
    name: "currency",
    label: "Currency",
    componentType: "combobox",
    disabled: false,
    inputType: "text",
    required: true,
    options: currencies,
    placeholder: "Please enter currency",
    rows: 0
  },
  {
    name: "totalAmount",
    label: "Total Amount",
    componentType: "input",
    disabled: false,
    inputType: "number",
    required: true,
    placeholder: "0.00",
    rows: 0,
  //    formula: (values: any) => {
  //   const total = Number(values.netAmount) ;
  //   const tax = Number(values.taxAmount) ; ;
  //   return total + tax;
  // },
  },

  {
    name: "taxAmount",
    label: "Tax Amount",
    componentType: "input",
    disabled: false,
    inputType: "number",
    required: true,
    placeholder: "0.00",
    rows: 0,
  //    formula: (values: any) => {
  //   const total = Number(values.totalAmount) ;
  //   const tax = Number(values.netAmount) ; ;
  //   return total  + tax;
  // },
  },
{
  name: "netAmount",
  label: "Net Amount",
  componentType: "input",
  disabled: false,
  inputType: "number",
  required: false,
  placeholder: "0.00",
  rows: 0,
  formula: (values: any) => {
    const total = Number(values.totalAmount) ;
    const tax = Number(values.taxAmount) ;
    return total - tax;
  },
  },
  {
    name: "payment",
    label: "Payment",
    componentType: "input",
    disabled: false,
    inputType: "number",
    required: false,
    placeholder: "0.00",
    rows: 0
  },
  {
    name: "paid",
    label: "Paid",
    componentType: "dropdown",
    disabled: false,
    // inputType: "",
    required: false,
    options: ["Yes", "No"],
    rows: 0
  },
{
  name: "paymentMethod",
  label: "Payment Method",
  componentType: "dropdown",
  disabled: false,
  required: true,
  options: [
    "Cash",
    "Credit Card",
    "Debit Card",
    "Bank Transfer",
    "Other",
  ],
  rows: 0
},

  {
    name: "isActive",
    label: "Active status",
    componentType: "hide",
    disabled: false,
    inputType: "dropdown",
    required: true,
    rows: 0
  },
  {
    name: "isDelete",
    label: "Delete status",
    componentType: "hide",
    disabled: false,
    inputType: "dropdown",
    required: true,
    rows: 0
  },
  {
    name: "discountAmount",
    label: "Discount Amount",
    componentType: "input",
    disabled: false,
    inputType: "number",
    required: true,
    placeholder: "0.00",
    rows: 0
  },
  {
    name: "lineItems",
    label: "Line Items",
    componentType: "input",
    disabled: true,
    inputType: "text",
    required: true,
    rows: 0
  },
];

export { invoiceTypes, paymentMethods, yesNo };